import React from 'react';
import { ShimmerPageLayout } from './Shimmer';
import Brand from './Brand';

const LoadingScreen = ({ 
  type = 'page', // 'page' | 'splash' | 'overlay'
  message = '',
  showBrand = true 
}) => {
  
  // Splash screen for app initialization
  if (type === 'splash') {
    return (
      <div className="fixed inset-0 bg-white dark:bg-gray-900 flex items-center justify-center z-50">
        <div className="text-center">
          {showBrand && (
            <div className="mb-8">
              <Brand size="lg" />
            </div>
          )}
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
          {message && (
            <p className="text-gray-600 dark:text-gray-400 text-sm">{message}</p>
          )}
        </div>
      </div>
    );
  }

  // Overlay loading for modal/popup content
  if (type === 'overlay') {
    return (
      <div className="absolute inset-0 bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm flex items-center justify-center z-40">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          {message && (
            <p className="text-gray-600 dark:text-gray-400 text-sm">{message}</p>
          )}
        </div>
      </div>
    );
  }

  // Page content shimmer loading
  return <ShimmerPageLayout />;
};

export default LoadingScreen;
